export const getProductListName = (): string => {
	const { pageType, usePageTypeForListName } = window.LittledataLayer;

	return usePageTypeForListName && pageType ? pageType : window.document.location.pathname;
};
